import PropTypes from 'prop-types'
import { Box } from '@chakra-ui/react'

import {
  SpecifiedCommercialTransaction,
  Terms,
  PrivacyPolicy,
  Help,
  PaymentComplete,
  MonthlyCourseRegistrationComplete,
  ActivationComplete,
  StopPiracy,
  Guide,
  Event,
  Campaign,
  Genres,
} from '@!/StaticPage/components'

const StaticPage = ({ pageType, params }) => {
  let component = null
  switch (pageType) {
    case 'specified_commercial_transaction':
      component = <SpecifiedCommercialTransaction />
      break
    case 'terms':
      component = <Terms />
      break
    case 'privacy_policy':
      component = <PrivacyPolicy />
      break
    case 'help':
      component = <Help />
      break
    case 'payment_complete':
      component = <PaymentComplete params={params} />
      break
    case 'monthly_course_registration_complete':
      component = <MonthlyCourseRegistrationComplete params={params} />
      break
    case 'activation_complete':
      component = <ActivationComplete params={params} />
      break
    case 'stop_piracy':
      component = <StopPiracy />
      break
    case 'guide':
      component = <Guide params={params} />
      break
    case 'event':
      component = <Event params={params} />
      break
    case 'campaign':
      component = <Campaign params={params} />
      break
    case 'genres':
      component = <Genres params={params} />
      break
    default:
      break
  }

  return <Box>{component}</Box>
}

StaticPage.propTypes = {
  pageType: PropTypes.string.isRequired,
  params: PropTypes.object, // `params`がundefinedの場合もあるため、isRequiredは不要
}

export default StaticPage
